import moment from 'moment';
import { getData } from '@/components/report/service';
import { computeWeightNotAbs, computeWeights } from '@/utils/query';
import { PlanDepartureProductQuery, PlanWeightDetialQuery, PreSiteToNextSiteQuery } from '../Tables/PlanDepartureTable/Sql';
import { getProductType } from '@/utils/query';
import { LeftSquareFilled } from '@ant-design/icons';
import { crudRequest } from '@/services/api';
import { sum } from 'lodash-es';
import { aggreArrItem, groupBys } from '@/utils/columnSearch';

export default {
  namespace: 'centerWeightViewModalsNew',
  state: {
    modalsVisible: false,
    /**
     * @modalsType
     * 1: 网点预到达
     * 2: 中转预到达
     * 3: 在库
    */
    modalsType: '',
    modalsTitle: '',
    modalsNextSite: '',

    // 预计
    estimateTitle: '',
    estimateList: [],
    estimatePage: 1,
    // 实际
    actualTitle: '',
    actualList: [],
    actualPage: 1,


    ProductTypeModalsVisible: false,
    nextSite: '',
    scanSite: '',

    planProductList: [],       // 预计到达产品类型图
    acount: 0,                 // 预计到达上一站总货量
    preSiteToNextSiteList: [], // 预计到达上一站分布
    planWeightDetialList: [], // 导出明细
  },
  effects: {
    // 重置
    *setReset(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          modalsVisible: false,
          estimateList: [],
          estimatePage: 1,
          actualList: [],
          actualPage: 1,

        },
      });
    },
    *getSelect({ payload }, { put }) {
      yield put({ type: 'update', payload: { ...payload } });
      // yield put({ type: 'getData' });
      crudRequest('/api/route/centerweightview/search_detail')
      yield put({ type: 'getDataSource' });
    },
    *getDataSource(_, { call, put, select }) {
      let { startDate, endDate, datadbName } = yield select(({ centerWeightViewNew }) => {
        return {
          startDate: moment(centerWeightViewNew.dateRange[0]).format(centerWeightViewNew.defualtDateFormat),
          endDate: moment(centerWeightViewNew.dateRange[1]).format(centerWeightViewNew.defualtDateFormat),
          datadbName: centerWeightViewNew.datadbName
        }
      });
      const { modalsNextSite: nextSite, scanSite, modalsType } =
        yield select(({ centerWeightViewModalsNew }) => centerWeightViewModalsNew)
      const isOriginCenter = modalsType === 1 ? '是' : '否'
      const params = { scanSite, nextSite, startDate, endDate, isOriginCenter }
      const { plan } = PlanWeightDetialQuery(params)
      let planProductList = yield call(getData, plan, datadbName)
      const preSites = planProductList.map(m => m.preSite)
      const { actual } = PlanWeightDetialQuery({ ...params, preSites })
      let actualProductList = yield call(getData, actual, datadbName)

      const dataSource = []
      planProductList.forEach(planItem => {
        let {
          waybillNo, preSite, calcWeight, goodsWeight,
          goodsVolume, productType, ticket, piece
        } = planItem
        const find = actualProductList.find(actualItem => {
          return (
            planItem.waybillNo === actualItem.waybillNo &&
            planItem.preSite === actualItem.preSite &&
            planItem.productType === actualItem.productType
          )
        })
        if (find) {
          calcWeight = calcWeight - find.calcWeight
          goodsWeight = goodsWeight - find.goodsWeight
          goodsVolume = goodsVolume - find.goodsVolume
          ticket = ticket - find.ticket
          piece = piece - find.piece
        }
        if (piece > 0) {
          // acount += calcWeight
          dataSource.push({
            waybillNo, preSite, calcWeight, goodsWeight,
            goodsVolume, productType, ticket, piece
          })
        }
      })
      yield put({ type: 'getPlanDepartureProduct', payload: { dataSource } });
      yield put({ type: 'getPreSiteToNextSite', payload: { dataSource } });
      yield put({ type: 'update', payload: { planWeightDetialList: dataSource } })
    },
    *getPlanDepartureProduct({ payload: { dataSource } }, { call, put, select }) {
      let dataSourceGroup = groupBys(dataSource, 'productType')
      let planProductList = []
      Object.keys(dataSourceGroup).map(item => {
        const aggResult = aggreArrItem(
          dataSourceGroup[item],
          ['calcWeight']
        )
        planProductList.push(aggResult)
      })
      planProductList = planProductList.map(item => {
        return ({ name: item.productType, value: computeWeightNotAbs(item.calcWeight) })
      })
      yield put({ type: 'update', payload: { planProductList } })
    },
    *getPreSiteToNextSite({ payload: { dataSource } }, { call, put, select }) {
      let acount = 0
      let dataSourceGroup = groupBys(dataSource, 'preSite')
      let preSiteToNextSiteList = []
      Object.keys(dataSourceGroup).map(item => {
        const aggResult = aggreArrItem(
          dataSourceGroup[item],
          ['calcWeight', 'goodsVolume', 'ticket', 'piece']
        )
        acount = acount + (aggResult?.calcWeight || 0)
        preSiteToNextSiteList.push(aggResult)
      })
      preSiteToNextSiteList = preSiteToNextSiteList.sort((a, b) => b.calcWeight - a.calcWeight).map(item => ({
        ...item, proportion: (item.calcWeight / acount * 100).toFixed(1)
      }))
      yield put({ type: 'update', payload: { preSiteToNextSiteList, acount } })
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}
